import { useContext, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { Country } from "../../../../../components/forms/country";
import { ConfigContext } from "../../../../../pages/token-onboarding/single/config-context";
import { validationFields } from "../../../../common/models/fields";
import { FieldHook, RenderFuncProps } from "../common";

const Elem = ({ item }: RenderFuncProps) => {
  const { config } = useContext(ConfigContext);
  const name = validationFields.countryOfResidence.useName();
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name: item.field,
  });
  return (
    <>
      <div>{name}</div>
      <Country
        exclude={config.configuration.prohibitedCountries}
        {...field}
        fullWidth
        error={!!error}
        helperText={error?.message}
      />
    </>
  );
};

export const useCountryOfResidenceField: FieldHook = () => {
  const schema = validationFields.countryOfResidence.useSchema();
  return useMemo(
    () => ({
      schema,
      elem: Elem,
    }),
    [schema]
  );
};
